module.exports = __webpack_public_path__ + "img/logo-light.0c34cd28.png";